import { render, staticRenderFns } from "./Campus.vue?vue&type=template&id=71698320&"
import script from "./Campus.vue?vue&type=script&lang=js&"
export * from "./Campus.vue?vue&type=script&lang=js&"
import style0 from "./Campus.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports